import React, { useState, useEffect, useRef } from "react";
import Container from "./Container";
import Tab from "./Tab";
import SipAndSwp from "./SipAndSwp";
import Lumpsum from "./Lumpsum";
import { FreeAmountModal } from "./FreeAmountModal";
import ChartComponent from "./ChartComponent";
import { Button } from "./Button";
import { useDispatch, useSelector } from "react-redux";
import InfoIcon from "../assets/images/Info-icon.svg";
import {
  setInvestmentDataSIP,
  setIsOpen,
  setRemoveFields,
} from "../redux/calculations/slice";
import {
  setInvestmentDataLUM,
  setIsOpenLum,
  setRemoveLumpsumFields,
} from "../redux/calculations/lumpsumSlice";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";
import { useNavigate, useParams } from "react-router-dom";
import OptionCal from "./OptionCal";
import SipTable from "../tables/SipTable";
import LumpsumTable from "../tables/Lumpsumtable";
import { setActiveCalculator } from "../redux/calculations/calculaterSlice";
import useLocale from "../../src/locales/index";
import i18n from "../i18n";
import { Helmet } from "react-helmet";
import { setActiveTab as setActiveTabAIAnalysis } from "../redux/aiAnalysis/aiAnalysisSlice";
import ExplainWithAI from "./ExplainWithAI";
import AIAnalysisModal from "./AIAnalysisModal";
import ExplainTerm from "./ExplainTerm";
import AppPromo from "./AppPromo";

const SIPBoard = ({ activeTab, setActiveTab, children }) => {
  const title = activeTab === 0 ? "SIP" : "Lumpsum";
  const navigate = useNavigate();
  const { calculatorType } = useParams();

  const dispatch = useDispatch();
  const cAccept = localStorage.getItem("grow-cookies");
  const cookieAccept = JSON.parse(cAccept);
  const { activeCalculator } = useSelector((state) => state.calculator);
  const [showTable, setShowTable] = useState(false);
  const { textData } = useLocale();
  const [direction, setDirection] = useState("ltr");
  const resultRef = useRef(null);

  // Mapping between URL paths and calculator IDs
  const pathToCalculatorMap = {
    "sip-investment-calculator": "sipCalc",
    "personal-loan-calculator": "personalLoanCalc",
    "fixed-deposit-calculator": "FDCalc",
    "recurring-deposit-calculator": "RDCalc",
    "debt-to-income-ratio-calculator": "DTICalc",
    "net-worth-calculator": "netWorthCalc",
    "loan-payoff-calculator": "earlyLoanCalc",
    "student-education-loan-calculator": "educationLoanCalc",
    "credit-card-payoff-calculator": "creditCardPayoffCalc",
    "business-loan-calculator": "businessLoanCalc",
    "gst-tax-calculator": "GSTCalc",
    "salary-calculator": "salaryCalc",
    "pension-calculator": "pensionCalc",
    "car-lease-calculator": "carCalc",
    "mortgage-loan-refinance-calculator": "mortgageCalc",
    "401k-retirement-calculator": "contributionCalc",
    "saving-goal-calculator": "savingCalc",
    "loan-to-value-calculator": "loanToValueCalc",
  };

  // Get the calculator ID from the URL path
  const calculatorId = pathToCalculatorMap[calculatorType] || calculatorType;

  const [calcDone, setCalcDone] = useState(false);
  const {
    age,
    monthlyInvestment,
    incrementPerYear,
    approxReturn,
    noOfInvestementYear,
    swpStartYear,
    yearlyWithdraw,
    yearlyIncrementInWithdrawSwp,
    isOpen,
    investmentAmounts,
    sipErrors,
    selectedOption,
  } = useSelector((state) => (activeTab === 0 ? state.sip : state.lum));
  const calculators = [
    {
      name: textData.filterDropDown.sipCalc,
      path: "/calculator/sip-investment-calculator",
    },
    {
      name: textData.filterDropDown.personalLoanCalc,
      path: "/calculator/personal-loan-calculator",
    },
    {
      name: textData.filterDropDown.FDCalc,
      path: "/calculator/fixed-deposit-calculator",
    },
    {
      name: textData.filterDropDown.contributionCalc,
      path: "/calculator/401k-retirement-calculator",
    },
    {
      name: textData.filterDropDown.RDCalc,
      path: "/calculator/recurring-deposit-calculator",
    },
    {
      name: textData.filterDropDown.DTICalc,
      path: "/calculator/debt-to-income-ratio-calculator",
    },
    {
      name: textData.filterDropDown.GSTCalc,
      path: "/calculator/gst-tax-calculator",
    },
    {
      name: textData.filterDropDown.pensionCalc,
      path: "/calculator/pension-calculator",
    },
    { name: textData.showMore, path: "/" },
  ];

  useEffect(() => {
    const rtlLanguages = ["ar", "fa", "ur"];
    const currentLang = i18n.language;

    if (rtlLanguages.includes(currentLang)) {
      setDirection("rtl");
      document.documentElement.setAttribute("dir", "rtl");
    } else {
      setDirection("ltr");
      document.documentElement.setAttribute("dir", "ltr");
    }
  }, [i18n.language]);

  useEffect(() => {
    dispatch(setActiveTabAIAnalysis(activeTab === 0 ? "sip" : "lum"))
  }, [activeTab, dispatch, setActiveTab])

  const handleCalculationDone = () => {
    setCalcDone(true);
  };

  React.useEffect(() => {
    if (
      React.Children.count(children) === 1 &&
      React.isValidElement(children)
    ) {
      const childWithProps = React.cloneElement(children, {
        onCalculationDone: handleCalculationDone,
      });
      children = childWithProps;
    }
  }, [children]);

  useEffect(() => {
    setCalcDone(false);
  }, [
    age,
    monthlyInvestment,
    incrementPerYear,
    approxReturn,
    noOfInvestementYear,
    swpStartYear,
    yearlyWithdraw,
    yearlyIncrementInWithdrawSwp,
    investmentAmounts,
  ]);

  const handleClick = (path) => {
    dispatch(setActiveCalculator(""));
    navigate(path);
  };

  const resetValues = () => {
    dispatch(setRemoveFields());
    dispatch(setRemoveLumpsumFields());
  };
  const generateData = () => {
    const data = [];
    let totalInvestment = 0;
    let currentMonthlyInvestment =
      typeof monthlyInvestment === "string"
        ? monthlyInvestment.replace(/,/g, "")
        : String(monthlyInvestment);
    let yearlyWithdrawAmt =
      typeof yearlyWithdraw === "string"
        ? yearlyWithdraw.replace(/,/g, "")
        : String(yearlyWithdraw);
    let ageCount = age;
    let swpStartYearCount = swpStartYear;
    let previousYearReturn = 0;

    let yearlyReturnAfterSWP = 0;
    for (let year = 1; year <= 45; year++) {
      const investmentAmount = parseFloat(investmentAmounts[year - 1]) || 0;

      const yearlyInvestment =
        activeTab === 0
          ? currentMonthlyInvestment * 12 + investmentAmount
          : Number(currentMonthlyInvestment) + investmentAmount;
      totalInvestment += yearlyInvestment;

      let yearlyReturn = 0;

      if (year === 1) {
        yearlyReturn =
          yearlyInvestment * (approxReturn / 100) + yearlyInvestment;
        previousYearReturn = yearlyReturn;
      } else {
        yearlyReturn =
          (previousYearReturn +
            (year <= noOfInvestementYear ? yearlyInvestment : 0)) *
          (approxReturn / 100) +
          (year <= noOfInvestementYear ? yearlyInvestment : 0) +
          previousYearReturn;
        previousYearReturn = yearlyReturn;
      }
      let swpAmount = 0;
      if (year >= swpStartYear) {
        swpAmount =
          yearlyWithdrawAmt *
          Math.pow(1 + yearlyIncrementInWithdrawSwp / 100, year - swpStartYear);
      }
      if (year === 1) {
        yearlyReturnAfterSWP =
          yearlyInvestment * (approxReturn / 100) + yearlyInvestment;
      } else {
        yearlyReturnAfterSWP =
          ((year <= noOfInvestementYear ? yearlyInvestment : 0) +
            yearlyReturnAfterSWP -
            swpAmount) *
          (approxReturn / 100) +
          (yearlyReturnAfterSWP +
            (year <= noOfInvestementYear ? yearlyInvestment : 0) -
            swpAmount);
      }
      let monthlyReturn = swpAmount / 12;
      let tabName = activeTab === 0 ? "sipCalc" : "lumpsumCalc";

      let ltcgAmount = 0;
      if (swpStartYear === 1) {
        let a = swpAmount;
        ltcgAmount = (a * 15) / 100;
      } else {
        let a = swpAmount;
        ltcgAmount = (a * 10) / 100;
      }

      data.push({
        tabName: tabName,
        year,
        investmentAmounts: investmentAmount,
        age: ageCount++,
        swpStartYear: swpStartYearCount <= year ? swpStartYearCount++ : year,
        monthlyInvestment:
          year <= noOfInvestementYear
            ? Math.round(currentMonthlyInvestment)
            : "",
        yearlyInvestment:
          year <= noOfInvestementYear ? Math.round(yearlyInvestment) : "",
        totalInvestment:
          year <= noOfInvestementYear ? Math.round(totalInvestment) : "",
        yearlyReturn: Math.round(yearlyReturn),
        swpAmount: swpAmount,
        monthlyReturn: Math.round(monthlyReturn),
        yearlyReturnAfterSWP:
          yearlyWithdraw === "" ? "" : Math.round(yearlyReturnAfterSWP),
        ltcgAmount: year >= swpStartYear ? Math.round(ltcgAmount) : "",
        // ltcgAmount: year >= swpStartYear ? Math.ceil(ltcgAmount):'',
      });

      if (year < noOfInvestementYear) {
        currentMonthlyInvestment *= 1 + incrementPerYear / 100;
      }
    }

    dispatch(
      activeTab === 0 ? setInvestmentDataSIP(data) : setInvestmentDataLUM(data)
    );

    setCalcDone(true);

    return data;
  };

  useEffect(() => {
    !sipErrors && setShowTable(false);
  }, [sipErrors]);

  const descriptionContent = (
    <div className="p-4 sm:p-5 w-full bg-[#F6F8FB] rounded-xl">
      <h2 className="text-black text-base sm:text-xl font-bold sm:font-medium">
        {textData.sipContent.title}
      </h2>
      <p className="leading-relaxed mt-2 text-sm sm:text-[15px]">
        {textData.sipContent.description}
      </p>

      <h2 className="text-black text-base sm:text-xl font-bold sm:font-medium mt-5">
        {textData.sipContent.howItWorks.title}
      </h2>
      <p className="leading-relaxed mt-2 text-sm sm:text-[15px]">
        {textData.sipContent.howItWorks.paragraph}
      </p>

      <p className="font-medium bg-[#E0E4F0] text-sm sm:text-base p-3 mt-3">
        <strong>
          M = P × ((1 + i)<sup>n</sup> – 1 / i) × (1 + i) + L × (1 + i)
          <sup>n</sup>
        </strong>{" "}
      </p>

      <table className="border-collapse mt-4 w-full">
        <thead></thead>
        <tbody>
          <tr>
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.sipContent.tableContent[0].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.sipContent.tableContent[0].description}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.sipContent.tableContent[1].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.sipContent.tableContent[1].description}
            </td>
          </tr>
          <tr>
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.sipContent.tableContent[2].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.sipContent.tableContent[2].description}
            </td>
          </tr>
          <tr>
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.sipContent.tableContent[3].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.sipContent.tableContent[3].description}
            </td>
          </tr>
          <tr>
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.sipContent.tableContent[4].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.sipContent.tableContent[4].description}
            </td>
          </tr>
        </tbody>
      </table>

      <h2 className="text-black text-base sm:text-xl font-bold sm:font-medium mt-8">
        {textData.sipContent.stepsToUse.title}
      </h2>
      <ol className="list-decimal px-5 leading-relaxed mt-3 text-sm sm:text-[15px]">
        <li>
          <strong> {textData.sipContent.stepsToUse.steps[0].tag}:</strong>{" "}
          {textData.sipContent.stepsToUse.steps[0].description}
        </li>
        <li>
          <strong> {textData.sipContent.stepsToUse.steps[1].tag}:</strong>{" "}
          {textData.sipContent.stepsToUse.steps[1].description}
        </li>
        <li>
          <strong> {textData.sipContent.stepsToUse.steps[2].tag}:</strong>{" "}
          {textData.sipContent.stepsToUse.steps[2].description}
        </li>
        <li>
          <strong> {textData.sipContent.stepsToUse.steps[3].tag}:</strong>{" "}
          {textData.sipContent.stepsToUse.steps[3].description}
        </li>
        <li>
          <strong> {textData.sipContent.stepsToUse.steps[4].tag}:</strong>{" "}
          {textData.sipContent.stepsToUse.steps[4].description}
        </li>
        <li>
          <strong> {textData.sipContent.stepsToUse.steps[5].tag}:</strong>{" "}
          {textData.sipContent.stepsToUse.steps[5].description}
        </li>
      </ol>

      <h2 className="text-black text-base sm:text-xl font-bold sm:font-medium mt-8">
        {textData.sipContent.benefits.title}
      </h2>
      <ul className="list-disc px-5 leading-relaxed mt-3 text-sm sm:text-[15px]">
        <li>
          <strong> {textData.sipContent.benefits.points[0].tag}:</strong>
          {textData.sipContent.benefits.points[0].description}
        </li>
        <li>
          <strong> {textData.sipContent.benefits.points[1].tag}:</strong>
          {textData.sipContent.benefits.points[1].description}
        </li>
        <li>
          <strong> {textData.sipContent.benefits.points[2].tag}:</strong>
          {textData.sipContent.benefits.points[2].description}
        </li>
        <li>
          <strong> {textData.sipContent.benefits.points[3].tag}:</strong>
          {textData.sipContent.benefits.points[3].description}
        </li>
        <li>
          <strong> {textData.sipContent.benefits.points[4].tag}:</strong>
          {textData.sipContent.benefits.points[4].description}
        </li>
      </ul>

      <h2 className="text-black text-base sm:text-xl font-bold sm:font-medium mt-5">
        {textData.sipContent.keyConsiderations.title}
      </h2>
      <ul className="list-disc px-5 leading-relaxed mt-3 text-sm sm:text-[15px]">
        <li>
          <strong>
            {textData.sipContent.keyConsiderations.points[0].tag}:
          </strong>{" "}
          {textData.sipContent.keyConsiderations.points[0].description}
        </li>
        <li>
          <strong>
            {textData.sipContent.keyConsiderations.points[1].tag}:
          </strong>{" "}
          {textData.sipContent.keyConsiderations.points[1].description}
        </li>
        <li>
          <strong>
            {textData.sipContent.keyConsiderations.points[2].tag}:
          </strong>{" "}
          {textData.sipContent.keyConsiderations.points[2].description}
        </li>
        <li>
          <strong>
            {textData.sipContent.keyConsiderations.points[3].tag}:
          </strong>{" "}
          {textData.sipContent.keyConsiderations.points[3].description}
        </li>
        <li>
          <strong>
            {textData.sipContent.keyConsiderations.points[4].tag}:
          </strong>{" "}
          {textData.sipContent.keyConsiderations.points[4].description}
        </li>
      </ul>
    </div>
  );

  const descriptionLumpContent = (
    <div className="p-4 sm:p-5 w-full bg-[#F6F8FB] rounded-xl">
      <h2 className="text-black text-base sm:text-xl font-bold sm:font-medium">
        {textData.lumpSumSWPContent.title}
      </h2>
      <p className="leading-relaxed mt-2  text-sm sm:text-[15px]">
        {textData.lumpSumSWPContent.description}
      </p>

      <h2 className="text-black text-base sm:text-xl font-bold sm:font-medium mt-5">
        {textData.lumpSumSWPContent.howItWorks.title}
      </h2>
      <p className="leading-relaxed mt-2 text-sm sm:text-[15px]">
        {textData.lumpSumSWPContent.howItWorks.paragraph}
      </p>

      <p className="font-medium bg-[#E0E4F0] text-sm sm:text-base p-3 mt-3">
        <strong>
          A = (P + L) × (1 + r/n)<sup>nt</sup>
        </strong>
      </p>

      <table className="border-collapse mt-4 w-full">
        <thead></thead>
        <tbody>
          <tr>
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.lumpSumSWPContent.tableContent[0].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.lumpSumSWPContent.tableContent[0].description}
            </td>
          </tr>
          <tr className="bg-transparent">
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.lumpSumSWPContent.tableContent[1].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.lumpSumSWPContent.tableContent[1].description}
            </td>
          </tr>
          <tr>
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.lumpSumSWPContent.tableContent[2].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.lumpSumSWPContent.tableContent[2].description}
            </td>
          </tr>
          <tr>
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.lumpSumSWPContent.tableContent[3].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.lumpSumSWPContent.tableContent[3].description}
            </td>
          </tr>
          <tr>
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.lumpSumSWPContent.tableContent[4].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.lumpSumSWPContent.tableContent[4].description}
            </td>
          </tr>
          <tr>
            <td className="p-3 border border-gray-light w-1/3 font-bold text-sm sm:text-[15px]">
              {textData.lumpSumSWPContent.tableContent[5].symbol}
            </td>
            <td className="p-3 border border-gray-light w-2/3 text-sm sm:text-[15px]">
              {textData.lumpSumSWPContent.tableContent[5].description}
            </td>
          </tr>
        </tbody>
      </table>

      <h2 className="text-black text-base sm:text-xl font-bold sm:font-medium mt-8">
        {textData.lumpSumSWPContent.stepsToUse.title}
      </h2>
      <ol className="list-decimal px-5 leading-relaxed mt-3 text-sm sm:text-[15px]">
        <li>
          <strong>
            {" "}
            {textData.lumpSumSWPContent.stepsToUse.steps[0].tag}:
          </strong>{" "}
          {textData.lumpSumSWPContent.stepsToUse.steps[0].description}
        </li>
        <li>
          <strong>
            {" "}
            {textData.lumpSumSWPContent.stepsToUse.steps[1].tag}:
          </strong>{" "}
          {textData.lumpSumSWPContent.stepsToUse.steps[1].description}
        </li>
        <li>
          <strong>
            {" "}
            {textData.lumpSumSWPContent.stepsToUse.steps[2].tag}:
          </strong>{" "}
          {textData.lumpSumSWPContent.stepsToUse.steps[2].description}
        </li>
        <li>
          <strong>
            {" "}
            {textData.lumpSumSWPContent.stepsToUse.steps[3].tag}:
          </strong>{" "}
          {textData.lumpSumSWPContent.stepsToUse.steps[3].description}
        </li>
        <li>
          <strong>
            {" "}
            {textData.lumpSumSWPContent.stepsToUse.steps[4].tag}:
          </strong>{" "}
          {textData.lumpSumSWPContent.stepsToUse.steps[4].description}
        </li>
      </ol>

      <h2 className="text-black text-base sm:text-xl font-bold sm:font-medium mt-8">
        {textData.lumpSumSWPContent.benefits.title}
      </h2>
      <ul className="list-disc px-5 leading-relaxed mt-3 text-sm sm:text-[15px]">
        <li>
          <strong>{textData.lumpSumSWPContent.benefits.points[0].tag}:</strong>{" "}
          {textData.lumpSumSWPContent.benefits.points[0].description}
        </li>
        <li>
          <strong>{textData.lumpSumSWPContent.benefits.points[1].tag}:</strong>{" "}
          {textData.lumpSumSWPContent.benefits.points[1].description}
        </li>
        <li>
          <strong>{textData.lumpSumSWPContent.benefits.points[2].tag}:</strong>{" "}
          {textData.lumpSumSWPContent.benefits.points[2].description}
        </li>
        <li>
          <strong>{textData.lumpSumSWPContent.benefits.points[3].tag}:</strong>{" "}
          {textData.lumpSumSWPContent.benefits.points[3].description}
        </li>
        <li>
          <strong>{textData.lumpSumSWPContent.benefits.points[4].tag}:</strong>{" "}
          {textData.lumpSumSWPContent.benefits.points[4].description}
        </li>
      </ul>

      <h2 className="text-black text-base sm:text-xl font-bold sm:font-medium mt-5">
        {textData.lumpSumSWPContent.keyConsiderations.title}
      </h2>
      <ul className="list-disc px-5 leading-relaxed mt-3 text-sm sm:text-[15px]">
        <li>
          <strong>
            {textData.lumpSumSWPContent.keyConsiderations.points[0].tag}:
          </strong>{" "}
          {textData.lumpSumSWPContent.keyConsiderations.points[0].description}
        </li>
        <li>
          <strong>
            {textData.lumpSumSWPContent.keyConsiderations.points[1].tag}:
          </strong>{" "}
          {textData.lumpSumSWPContent.keyConsiderations.points[1].description}
        </li>
        <li>
          <strong>
            {textData.lumpSumSWPContent.keyConsiderations.points[2].tag}:
          </strong>{" "}
          {textData.lumpSumSWPContent.keyConsiderations.points[2].description}
        </li>
        <li>
          <strong>
            {textData.lumpSumSWPContent.keyConsiderations.points[3].tag}:
          </strong>{" "}
          {textData.lumpSumSWPContent.keyConsiderations.points[3].description}
        </li>
        <li>
          <strong>
            {textData.lumpSumSWPContent.keyConsiderations.points[4].tag}:
          </strong>{" "}
          {textData.lumpSumSWPContent.keyConsiderations.points[4].description}
        </li>
      </ul>
    </div>
  );

  const scrollToResult = () => {
    resultRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const tabs = [
    {
      title: textData.sipCalc.sip,
      content: (
        <SipAndSwp
          setShowTable={setShowTable}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          generateData={generateData}
          resetAllValues={resetValues}
          descriptionContent={descriptionContent}
          scrollToResult={scrollToResult}
        />
      ),
    },
    {
      title: textData.sipCalc.Lumpsum,
      content: (
        <Lumpsum
          setShowTable={setShowTable}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          generateData={generateData}
          resetAllValues={resetValues}
          descriptionContent={descriptionLumpContent}
          scrollToResult={scrollToResult}
        />
      ),
    },
  ];

  // Add this useEffect hook to the SIPBoard component to keep activeCalculator in sync with tab changes
  const handleNavigate = () => {
    navigate("/mainCards");
  };
  useEffect(() => {
    if (activeTab === 0) {
      dispatch(setActiveCalculator("sipCalc"));
    } else if (activeTab === 1) {
      dispatch(setActiveCalculator("lumpsumCalc"));
    }
  }, [activeTab]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  function graphDescription() {
    function investmentDuration() {
      function splitString() {
        let [_, lastYear] = selectedOption?.split("-");

        return lastYear === "1" ? "1 " : `${lastYear} `;
      }

      switch (selectedOption) {
        case textData.All:
          return "15-30 ";
        case null:
          return "45 ";
        default:
          return splitString();
      }
    }

    return `${textData.resultLable}  ${investmentDuration()} ${textData.year}.`;
  }
  const calculatorTitleMap = {
    sipCalc: "filterDropDown.sipCalc",
    lumpsumCalc: "filterDropDown.lumpsumCalc",
  };

  const isRTL = () => {
    const rtlLanguages = ["ar", "fa", "ur"];
    return rtlLanguages.includes(i18n.language);
  };

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((o, p) => o?.[p], obj);
  };

  const getCalculatorTitle = () => {
    const titleKey = calculatorTitleMap[calculatorId];
    if (titleKey && textData) {
      return getNestedValue(textData, titleKey);
    }
    return "Calculator";
  };

  const closeModal = () => {
    dispatch(activeTab === 0 ? setIsOpen(false) : setIsOpenLum(false));
  };
  return (
    <>
      <Helmet>
        <title>
          SIP Investment Calculator | Calculate SIP Returns Online
        </title>
        <meta
          name="description"
          content="SIP Investment Calculator Online helps you plan mutual fund investments, calculate SIP returns, and grow your wealth confidently. Start investing today!"
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://growlifefund.com/calculator/sip-investment-calculator"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="SIP Investment Calculator | Calculate SIP Returns Online"
        />
        <meta
          property="og:description"
          content="SIP Investment Calculator Online helps you plan mutual fund investments, calculate SIP returns, and grow your wealth confidently. Start investing today!"
        />
        <meta
          property="og:url"
          content="https://growlifefund.com/calculator/sip-investment-calculator"
        />
        <meta property="og:site_name" content="growlifefund" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="SIP Investment Calculator Online - GrowLifeFund"
        />

        {/* Robots */}
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div
        className={`flex gap-3 flex-col lg110:flex-row ${direction === "rtl" ? "rtl" : "ltr"
          }`}
      >
        <div className="flex container gap-3 flex-col">
          <div className="flex flex-col lg110:flex-row gap-3 justify-center">
            <div className="md:px-[80px] !pl-0 sm:px-[40px] lg:px-[10px] xl:px-[10px] mt-5 sm:mt-6 md:mt-6 text-start">
              <div className="pb-4">
                <span
                  className="text-base sm:text-base font-BlinkMacSystemFont font-medium text-blue-shade cursor-pointer"
                  onClick={handleNavigate}
                >
                  {textData.calculator}
                </span>
                <span className="text-gray-font text-base font-BlinkMacSystemFont font-medium">
                  {" "}
                  &gt; {getCalculatorTitle()}
                </span>{" "}
              </div>
              <OptionCal />
              <div className="border border-solid border-gray-light rounded-xl px-[31px] py-[16px] lg110:max-w-[705px] xl:w-[942px] xl:max-w-[942px] mx-0 sm:mx-auto">
                <div className="flex flex-col gap-[42px]">
                  <Container>
                    <div className="">
                      <div className="flex items-center justify-center gap-2">
                        <h1 className="lg:text-xl sm:text-lg text-[20px] md:max-w-full max-w-[260px]   text-black  font-lato-bold-700 text-center">
                          {textData.sipCalc.calculate}{" "}
                          <span className="bg-gradient-primary bg-clip-text text-[transparent]">
                            {title}{" "}
                          </span>
                          <span className="bg-gradient-primary bg-clip-text text-[transparent]">
                            {textData.sipCalc.invest}
                          </span>{" "}
                          {textData.sipCalc.return}
                        </h1>
                        <ExplainTerm term={`${title} Investment Calculator`} calculatorName={activeTab === "sip" ? "sip/ swp investment calculator" : "lumpsum investment calculator"} />
                      </div>
                      <div className="sm:pt-2 pb-4 text-center sm:max-w-[904px] max-w-[335px] w-full m-auto text-[14px] text-gray-font  font-lato-regular-400 pt-2">
                        {textData.sipCalc.description}
                      </div>
                    </div>
                  </Container>
                  <div className="bg-white mb-[20px] rounded-[24px] w-full lg:flex block px-0 py-0 gap-[42px]">
                    <div className="lg:max-w-[508px] w-full flex flex-col pb-6 lg:pb-0">
                      <Tab
                        tabs={tabs}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        setShowTable={setShowTable}
                        resetAllValues={resetValues}
                      />
                      <div className="flex justify-between items-center"></div>
                    </div>
                    <div ref={resultRef} className="w-full lg:w-[330px] lg:flex-shrink-0 bg-[#F6F8FB] rounded-[20px] md:mt-0 h-fit sm:p-[24px] p-[10px]">
                      <ChartComponent
                        activeTab={activeTab}
                        setShowTable={setShowTable}
                        calcDone={calcDone}
                      />
                      <div className="w-full sm:mt-[30px] mt-[30px]">
                        <div className="text-gray-font sm:text-[14px] flex gap-3 text-start text-[12px] font-lato-regular-400">
                          <img
                            src={InfoIcon}
                            alt="Info"
                            className="ml-2 w-4 h-4 mt-[4px]"
                            title="Systematic Withdrawal Plan (SWP) is a mutual fund withdrawal plan, if you invest a lumpsum or SIP in a mutual fund, you can set an amount you'll withdraw regularly and the frequency at which you'll withdraw."
                          />

                          {graphDescription()}
                        </div>
                      </div>
                      <div className="sm:mt-[25px] mt-[18px]">
                        <ExplainWithAI isDisabled={!calcDone} analysisType={calculatorType} calculatorName={calculatorType} className="mb-3" />
                        <Button
                          // disabled={
                          //   !sipErrors ||
                          //   monthlyInvestment === "0" ||
                          //   noOfInvestementYear === "" ||
                          //   !calcDone
                          //     ? true
                          //     : false
                          // }
                          className="w-full"
                          onClick={async () => {
                            if (cookieAccept && analytics) {
                              logEvent(analytics, "report_details");
                            }
                            setShowTable(true); // Set showTable state to true
                            setTimeout(() => {
                              const faqsForm =
                                document.getElementById("tableScroll"); // Get element with ID 'tableScroll'
                              if (faqsForm) {
                                const scrollMargin = 200; // Adjust this value as needed
                                const scrollPosition =
                                  faqsForm.getBoundingClientRect().top +
                                  window.pageYOffset -
                                  scrollMargin;
                                window.scrollTo({
                                  top: scrollPosition,
                                  behavior: "smooth",
                                }); // Scroll element into view smoothly
                              }
                            }, 100);
                          }}
                        >
                          {textData.details}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* {activeCalculator === 'sipCalc' && (
                  <SipTable showTable={showTable}/>
                )}

              {activeCalculator === 'lumpsumCalc' && (
                  <LumpsumTable showTable={showTable}/>
                )} */}
              </div>


              <FreeAmountModal
                onClose={closeModal}
                activeTab={activeTab}
                generateData={generateData}
              />
            </div>
            <div className=" lg:pl-[10px] sm:px-10 md:px-[80px] lg:px-[10px] xl:px-[10px] text-start">
              <div className="w-full lg:w-[303px] h-fit border border-gray-1 bg-white rounded-lg shadow-lg overflow-hidden lg110:mt-[63px] mx-auto">
                <h2 className="bg-gray-100 px-5 py-[14px] border-b border-gray-1 font-BlinkMacSystemFont font-semibold text-black-1 text-sm">
                  {textData.popularCalculator}
                </h2>
                {calculators.map((calc, index) => (
                  <button
                    key={index}
                    onClick={() => handleClick(calc.path)}
                    className={`w-full  px-5 py-[14px] ${isRTL() ? "text-right" : "text-left"
                      } text-sm text-black-1 hover:bg-gray-100 active: border-b border-gray-1 last:border-b-0`}
                  >
                    {calc.name}
                  </button>
                ))}
              </div>
              <div className="w-full lg:w-[303px] mx-auto">
                <AppPromo className="mt-6 w-full" />
              </div>
            </div>
          </div>
          <div className="lg110:max-w-[1040px] xl:w-full xl:max-w-none lg:w-[1280px]">

            {showTable && <div className="mt-5">
              <div className="lg:p-[20px] xl:p-[30px] p-[18px] border border-solid border-gray-light rounded-xl !pt-0">

                {showTable && (
                  <>
                    {activeTab === 0 && activeCalculator === "sipCalc" && (
                      <SipTable showTable={showTable} />
                    )}

                    {activeTab === 1 && activeCalculator === "lumpsumCalc" && (
                      <LumpsumTable
                        showTable={showTable}
                        activeCalculator={activeCalculator}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
            }
            {
              activeTab === 0 && (
                <div className="">
                  <div className="border border-solid border-gray-light rounded-xl  mt-5">
                    {descriptionContent}
                  </div>
                </div>
              )
            }

            {
              activeTab === 1 && (
                <div className="">
                  <div className="border border-solid border-gray-light rounded-xl  mt-5">
                    {descriptionLumpContent}
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div >

      <AIAnalysisModal />
    </>
  );
};

export default SIPBoard;
